/** @format */

import { TUser } from "../../redux-modules/declarations/maps/auth";

/** Ruoli ammessi alle comunicazioni intermittenti (stessi id del backend). */
const ROLE_ROOT = 1;
const ROLE_ADMIN = 2;

/**
 * true se l'utente è ROOT o AMMINISTRATORE.
 * Usa role_id quando il backend lo restituisce; altrimenti il nome del ruolo,
 * come già fatto in altre pagine (es. ViewUserEdit).
 */
export const isAdminOrRoot = (user?: TUser): boolean => {
  if (!user) return false;
  if (user.role_id !== undefined && user.role_id !== null) {
    return [ROLE_ROOT, ROLE_ADMIN].includes(Number(user.role_id));
  }
  return user.role === "ROOT" || user.role === "AMMINISTRATORE";
};
